export default {
  default: '#31405C',
  green: '#00AFAA',
  greenLight: '#4DC7C4',
  greenHighlight: '#E8F8F8',
  greenDark: '#00827E',
  purple: '#7A1BBE',
  purpleDark: '#630FA0',
  purpleHighlight: '#F1E9F7',
  purpleHeart: '#6929C4',
  lavender: '#F6F2FF',
  olive: '#6595aa',
  white: '#FFFFFF',
  black: '#000000',
  darkBlue: '#1920A3',
  lightBlue: '#236DE3',
  aliceBlue: '#EDF5FF',
  navyBlue: '#344969',
  blue: '#1D3FBD',
  beige: '#F6F6F6',
  red: 'red',
  whiteSmoke: '#F7F7F7',
  warning: '#FE6900',
  errorRed: '#DA1E28',
  errorBg: '#FFF1F1',

  grey: '#E8E8E8',
  grey1: '#9b9b9b',
  grey2: '#f7f7f7',
  grey3: '#6d7278',
  grey4: '#efefef',
  grey5: '#c3c3c3',
  grey6: '#D0D0D0',
  grey7: '#DCDCDC',

  disabled: 'rgba(0, 0, 0, 0.26)',

  shadow: 'rgba(0, 0, 0, 0.04)',
  shadow2: 'rgba(0, 0, 0, 0.12)',
  shadow3: 'rgba(0, 0, 0, 0.2)',
  shadow5: 'rgba(0, 0, 0, 0.6)',
  shadow6: 'rgba(0, 0, 0, 0.87)',

  border1: 'rgba(0, 0, 0, 0.16)',

  overlay: 'rgba(0,0,0,0.8)',
  transparent: 'rgba(0,0,0,0)',

  toolbarItemBackground: 'rgba(0,0,0,0.08)',

  lightGreyBg: 'rgba(109, 114, 120, 0.08)',

  warningBg: '#FFF4CC',
  oliveBg: 'rgba(101, 149, 170, 0.08)',

  purpleBg: 'rgba(122, 27, 190, 0.12)',
  purpleHoverBg: 'rgba(122, 27, 190, 0.24)',
};
